<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="offer manage">
          <div class="custom"/>
          <div class="options">
            <router-link
              v-if="isFibSite"
              slot="beforeDefinedSearch"
              class="button-search icon-index-1"
              target="_blank"
              :to="{ name: 'addStudentSimple', params: { acId: $route.params.id } }">
              <el-button
                type="primary"
                size="medium">添加学生信息
              </el-button>
            </router-link>
            <router-link
              v-if="isTrainingSite"
              slot="beforeDefinedSearch"
              class="button-search icon-index-1"
              target="_blank"
              :to="{ name: 'addSimple', params: { acId: $route.params.id } }">
              <el-button
                type="primary"
                size="medium">添加学生信息
              </el-button>
            </router-link>
            <el-form
              :model="searchData"
              inline>
              <jm-form-options
                :options="searchStructure"
                :option-data="searchData"
                :const-dict="constDict"/>
            </el-form>
          </div>
          <div class="operation">
            <el-button
              type="primary"
              :size="size"
              @click="getSearch">查询</el-button>
            <el-button
              type="primary"
              :size="size"
              @click="setSearchData">重置</el-button>
          </div>
          <jm-tableList
            url="/index/general_activity/showActivityLogs"
            :search-data="searchData"
            :refresh.sync="isSearch"
            :current-page.sync="currentPage">
            <el-table-column
              slot="status"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="status"
            >
              <template slot-scope="scope">
                <el-tag v-if="!scope.row.remark_time" type="danger">未处理</el-tag>
                <el-tag v-if="scope.row.remark_time" type="success">已处理</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              v-if="!currentUser.roleids.find(i => i === 1)"
              slot="tel"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="tel"
            >
              <template slot-scope="scope">
                {{ currentUser.userid === Number(scope.row.custom_promoter) ? scope.row.tel : '***' }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="!currentUser.roleids.find(i => i === 1)"
              slot="qq"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="qq"
            >
              <template slot-scope="scope">
                {{ currentUser.userid === Number(scope.row.custom_promoter) ? scope.row.qq : '***' }}
              </template>
            </el-table-column>
            <el-table-column
              v-if="!currentUser.roleids.find(i => i === 1)"
              slot="weixin"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="weixin"
            >
              <template slot-scope="scope">
                {{ currentUser.userid === Number(scope.row.custom_promoter) ? scope.row.weixin : '***' }}
              </template>
            </el-table-column>
            <el-table-column
              slot="visit"
              slot-scope="scope"
              v-bind="scope.attrs"
              :label="scope.label"
              property="visit"
            >
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.visit.vist_str"
                  placement="top-start">
                  <span>{{ scope.row.visit.instime }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="280"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-document"
                  @click="visit(scope.row)">活动回访</el-button>
                <a target="_blank" :href="getStudentUrl(scope.row)">
                  <el-button type="primary" size="mini">查看资源</el-button>
                </a>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>

    <el-dialog
      title="活动回访"
      :visible.sync="isVisitVisiting"
      width="80%"
    >
      <el-form v-if="isVisitVisiting" label-width="100px" :model="visitShadow" :rules="rules">
        <el-form-item
          label="方式"
          class="d-inline-block"
          prop="visit_kind">
          <jm-dict-select
            clearable
            dict="dataset.visit.way"
            v-model="visitShadow.visit_kind"
          />
        </el-form-item>
        <el-form-item label="快捷记录" class="d-inline-block">
          <jm-dict-select
            clearable
            dict="dataset.visit.quickRecord"
            v-model="visitShadow['record']"
            @change="quickFill"
          />
        </el-form-item>
        <el-form-item label="回访类型" class="d-inline-block" :prop="($hasPermission(1) || isNormal) ? 'visit_type' : ''">
          <jm-dict-select
            :clearable="$hasPermission(1) || isNormal"
            dict="dataset.visit.type"
            v-model="visitShadow['visit_type']"
            :filter="visitTypeFilter"
          />
        </el-form-item>
        <el-form-item label="记录" prop="ac_remark">
          <el-input
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入内容"
            prop="ac_remark"
            v-model="visitShadow['ac_remark']"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isVisitVisiting = false">关 闭</el-button>
        <el-button type="primary" @click="visitSubmit">保 存</el-button>
      </span>
      <p class="padding-y font-md">相同线索记录</p>
      <jm-tableList
        v-if="isVisitVisiting"
        :url="'/index/general_activity/getLeads'"
        :refresh.sync="exporting"
        row-key="id"
        :search-data="searchDataLead"
        :no-pagination="true"
        class="adminList"
      >
        <el-table-column
          slot="tel"
          v-if="!currentUser.roleids.find(i => i === 1)"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="tel"
        >
          <template slot-scope="scope">
            {{ currentUser.userid === Number(scope.row.custom_promoter) ? scope.row.tel : '***' }}
          </template>
        </el-table-column>
        <el-table-column
          slot="qq"
          v-if="!currentUser.roleids.find(i => i === 1)"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="qq"
        >
          <template slot-scope="scope">
            {{ currentUser.userid === Number(scope.row.custom_promoter) ? scope.row.qq : '***' }}
          </template>
        </el-table-column>
        <el-table-column
          slot="weixin"
          v-if="!currentUser.roleids.find(i => i === 1)"
          slot-scope="scope"
          v-bind="scope.attrs"
          :label="scope.label"
          property="weixin"
        >
          <template slot-scope="scope">
            {{ currentUser.userid === Number(scope.row.custom_promoter) ? scope.row.weixin : '***' }}
          </template>
        </el-table-column>
      </jm-tableList>
    </el-dialog>
  </div>
</template>
<script>
import student from '@/pages/student/student';
import jmTableList from '@/components/data/tableList';
import { jmDictSelect } from '@/components/tool';
import { filterVisible } from '@/utils/utils';
import jmFormOptions from '@/components/data/formOptions';
import * as visitDataset from '@/dataset/visit';

// 搜索项结构
const searchStructure = [
  {
    visible: 'status',
    field: 'status',
    label: '处理状态',
    placeholder: '处理状态',
    component: 'dict',
    type: 'dataset',
    dict: 'student',
    name: 'dealStatus',
    clearable: true,
    column: [24, 12, 8, 8]
  },
  {
    visible: 'custom_promoter',
    field: 'custom_promoter',
    label: '活动推广人',
    placeholder: '活动推广人',
    component: 'mgSelect',
    multiple: false,
    clearable: true,
    constKey: 'view_userid',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'tel',
    field: 'tel',
    label: '电话',
    placeholder: '电话',
    component: 'input',
    clearable: true,
    column: [24, 12, 8, 8]
  },
  {
    visible: 'leadType',
    field: 'leadType',
    label: '线索类别',
    placeholder: '线索类别',
    component: 'dict',
    type: 'dataset',
    dict: 'student',
    name: 'leadType',
    clearable: true,
    column: [24, 12, 8, 8]
  },
  {
    visible: 'countryId',
    field: 'country_id',
    label: '意向国家',
    placeholder: '意向国家',
    component: 'select',
    multiple: true,
    clearable: true,
    constKey: 'countries',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'creater_key',
    field: 'creater_key',
    label: '采集功能',
    placeholder: '采集功能',
    component: 'select',
    clearable: true,
    constKey: 'creater_key',
    column: [24, 12, 8, 8]
  },
  {
    visible: 'level',
    field: 'level',
    label: '客户分级',
    placeholder: '客户分级',
    component: 'select',
    clearable: true,
    constKey: 'level',
    column: [24, 12, 8, 8]
  }
];
// 搜索数据结构

export default {
  components: {
    jmTableList, jmDictSelect, jmFormOptions
  },
  data() {
    return {
      tableListInited: false,
      size: 'small',
      searchStructure,
      searchData: {},
      searchDataLead: {},
      currentPage: 1,
      constDict: {},
      isVisitVisiting: false,
      visitShadow: {},
      currentRow: {},
      leads: [],
      isSearch: false,
      urlPrefix: '',
      exporting: false,
      currentUser: this.$store.state.userinfo,
      isAdmin: false,
      rules: {
        ac_remark: [{ required: true, message: '记录不能为空', trigger: 'change' }]
      }
    };
  },
  methods: {
    filterVisible,
    async visit (row) {
      this.isVisitVisiting = true;
      this.visitShadow = {};
      this.leads = [];
      const {
        weixin, tel, qq, id, userid
      } = row;
      let visitKind = row.visit_kind;
      let visitType = row.visit_type;
      let acRemark = row.acRemark;

      this.visitShadow = {
        id,
        visit_kind: visitKind,
        visit_type: visitType,
        ac_remark: acRemark,
        userid
      };
      this.searchDataLead = {
        id, weixin, tel, qq
      };
      this.exporting = true;
    },
    async visitSubmit () {
      const activityId = this.$route.params.id;
      const postdata = {
        ...this.visitShadow,
        site_name: this.$siteName,
        activity_id: activityId
      };
      if (!postdata.ac_remark || /^\s+$/.test(postdata.ac_remark)) {
        this.$message.warning('记录不能为空');
        return false;
      }
      await this.$http._post({
        url: '/index/general_activity/saveActivityLog',
        data: postdata
      });
      this.getSearch();
      this.isVisitVisiting = false;
    },
    quickFill(v) {
      visitDataset.quickRecord.forEach((item) => {
        if (item.value === v) {
          this.visitShadow.ac_remark = item.label;
        }
      });
    },
    getStudentUrl(row) {
      switch (row.site_name) {
        case 'training':
          return `/customer/edit/${row.userid}`;
        case 'job':
          return `/member/edit/${row.userid}`;
        default:
          return `${this.urlPrefix}/student/edit/${row.userid}`;
      }
    },
    /**
     * 回访类型，感觉不同角色使用不用的类型
     */
    visitTypeFilter(item) {
      if (this.$hasPermission([91, 1, 98, 114])) {
        return true;
      }

      if (this.$hasPermission([117])) {
        if (item.value === 2 || item.value === 3) {
          return true;
        }
        return false;
      }

      if (this.isNormal) {
        if (item.value === 1 || item.value === 2) {
          return true;
        }
        return false;
      }

      if (item.value === 3) {
        return true;
      }
      return false;
    },
    // 初始默认搜索值
    setSearchData() {
      this.searchData = Object.assign({}, this.initData);
    },
    getSearch() {
      this.currentPage = 1;
      this.isSearch = false;
      Object.values(this.searchData).forEach(() => {
        this.isSearch = true;
      });
    },
    getResourceTag(lv) {
      let type = '';
      switch (lv) {
        case 65:
          type = 'danger';
          break;
        case 57:
          type = 'success';
          break;
        case 53:
          type = 'warning';
          break;
        default:
          type = 'info';
          break;
      }
      return type;
    },
    changeDeal(row) {
      this.$http
        ._post({
          url: '/index/general_activity/changeDeal',
          data: { userid: row.crm_userid, is_deal: row.is_deal }
        })
        .then(() => {
          row.is_deal = !row.is_deal;
        });
      return row;
    }
  },
  created() {
    this.initData = { id: this.$route.params.id };
    this.setSearchData();
    // 因为默认查询字段为空，初始设置查询数据字段
    this.$http._get({
      url: '/index/general_activity/show'
    }).then(({ data }) => {
      this.constDict = data.const_dict;
    });
    if (this.$siteName === 'fib') {
      this.urlPrefix = '/frontend';
    }
    this.isAdmin = Boolean(this.currentUser.roleids.find(i => i === 1));
    console.log('IS_ADMIN: ', this.isAdmin);
  },
  watch: {},
  mixins: [student]
};
</script>
<style>
.el-form {
  margin-top: 20px;
}
.padding-y {
  padding-top: .5rem;
  padding-bottom: .5rem;
}
.font-md {
  font-size: 1.1rem;
}
.offer.manage .operation {
  padding-bottom: 1em;
  text-align: center;
}
.offer.manage .options .el-form-item {
  display: -webkit-flex;
  display: flex;
  margin-bottom: 10px;
}

.offer.manage .options .el-form-item__label {
  min-width: 7em;
  padding-right: 8px;
}
.offer.manage .options .el-form-item__content {
  -webkit-flex: 1;
  flex: 1;
}
.offer.manage .options .el-date-editor--daterange.el-input,
.offer.manage .options .el-date-editor--daterange.el-input__inner,
.offer.manage .options .el-date-editor--timerange.el-input,
.offer.manage .options .el-date-editor--timerange.el-input__inner {
  width: 100%;
  white-space: nowrap;
}
.d-inline-block {
  display: inline-block;
}
</style>
